export const FormikErrorMessage = ({ message }) => {
  return (
    <p className="formError-msgShow" style={{ color: "#F82643", fontWeight: "bold" }}>
      <i className="fa-solid fa-circle-exclamation pr-2" />
      {message}
    </p>
  );
};
